import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

const GroundwaterModeSelector = ({ currentMode, onModeChange, indicatorName = 'Groundwater stress levels', headerAction }) => {
  const [showSeverityHelp, setShowSeverityHelp] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const helpIconRef = useRef(null);
  const tooltipRef = useRef(null);

  const modes = [
    { id: 'severity', label: 'Severity' },
    { id: 'gwl', label: 'Current Groundwater Level (Meters)' },
    { id: 'depletion_pct', label: 'Depletion Percentage' },
    { id: 'forecast', label: 'Forecasted Severity' }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showSeverityHelp &&
        helpIconRef.current &&
        !helpIconRef.current.contains(event.target) &&
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target)
      ) {
        setShowSeverityHelp(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showSeverityHelp]);

  const handleHelpClick = (e) => {
    e.stopPropagation();
    if (!showSeverityHelp && helpIconRef.current) {
      const rect = helpIconRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.bottom + 8,
        left: rect.left + rect.width / 2
      });
    }
    setShowSeverityHelp(!showSeverityHelp);
  };

  return (
    <div className="power-outage-mode-selector groundwater-mode-selector" style={{ position: 'relative' }}>
      <h4 className="viz-mode-title">{indicatorName} - Visualization Mode</h4>
      <div className="power-mode-tabs-row">
        <div className="power-mode-tabs" style={{ gridTemplateColumns: `repeat(${modes.length}, 1fr)` }}>
        {modes.map((mode) => (
          <div
            key={mode.id}
            className={`power-mode-tab ${currentMode === mode.id ? 'active' : ''}`}
            onClick={() => onModeChange(mode.id)}
            style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            {mode.label}
            {mode.id === 'severity' && (
              <>
                <span
                  ref={helpIconRef}
                  onClick={handleHelpClick}
                  style={{
                    marginLeft: '0.5rem',
                    width: '18px',
                    height: '18px',
                    borderRadius: '50%',
                    background: '#3498db',
                    color: 'white',
                    fontSize: '0.75rem',
                    fontWeight: 'bold',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    flexShrink: 0,
                    zIndex: 10
                  }}
                  title="Click for severity formula"
                >
                  ?
                </span>
              </>
            )}
          </div>
        ))}
        </div>
        {headerAction}
      </div>
      
      {showSeverityHelp &&
        ReactDOM.createPortal(
          <div
            ref={tooltipRef}
            style={{
              position: 'fixed',
              top: `${tooltipPosition.top}px`,
              left: `${tooltipPosition.left}px`,
              transform: 'translateX(-50%)',
              background: 'white',
              border: '1px solid #ddd',
              borderRadius: '6px',
              padding: '0.75rem',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              zIndex: 9999,
              minWidth: '260px',
              fontSize: '0.85rem',
              lineHeight: 1.6,
              pointerEvents: 'auto'
            }}
          >
            <div style={{ fontWeight: 600, marginBottom: '0.5rem', color: '#2c3e50' }}>
              Groundwater Severity (depletion_level_meters):
            </div>
            <div style={{ color: '#555' }}>
              <strong>LOW</strong>: value = 0<br />
              <strong>MEDIUM</strong>: value &lt; threshold (default 0.5 m)<br />
              <strong>HIGH</strong>: value &gt; threshold
            </div>
          </div>,
          document.body
        )}
    </div>
  );
};

export default GroundwaterModeSelector;
